const somenteDigitos = (v: string) => v.replace(/\D/g, '');
const normalizar = (v: string) => v.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

/** Filtra empresas por parte do nome ou do CNPJ (com ou sem pontuação). Busca vazia devolve todas. */
export const filtrarEmpresas = <T extends { nome: string; cnpj?: string | null }>(empresas: T[], busca: string): T[] => {
  const termo = normalizar(busca);
  if (!termo) return empresas;
  const digitos = somenteDigitos(busca);
  return empresas.filter(e =>
    normalizar(e.nome).includes(termo) || (digitos.length > 0 && somenteDigitos(e.cnpj ?? '').includes(digitos)));
};

/** Texto de busca sem acento, em minúsculas e sem espaços nas pontas. */
export const normalizarBusca = normalizar;

/** Filtra qualquer lista por parte do texto (sem diferenciar maiúsculas/acentos) em um ou mais campos. Busca vazia devolve tudo. */
export const filtrarPorTexto = <T,>(itens: T[], busca: string, textosDe: (item: T) => (string | null | undefined)[]): T[] => {
  const termo = normalizar(busca);
  if (!termo) return itens;
  return itens.filter(i => textosDe(i).some(t => normalizar(t ?? '').includes(termo)));
};
